import { useState } from "react";
import { Form, FormActions } from "../components/Controls/Form";
import API from "@src/API.js";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function Blacklist() {
  const [mode, setMode] = useState("enter");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get("email") || "";

  async function doBlacklistAsync() {
    if (!email) {
      toast.error("Missing email address on this blacklist link.");
      return;
    }
    const resp = await API.postAsync("/Blacklist", { email });
    if (resp && resp.ok) {
      setMode("bye");
    } else {
      toast.error(resp?.jsonData?.message || "Unable to update blacklist preference");
    }
    return resp;
  }

  if (mode === "bye") {
    return (
      <div className="loginPage centered">
        <p>
          Thank you for letting us know your preferences. At any time in the future, feel free to come back and register
          to remove yourself from this email block list.
        </p>
        <p>
          <Link to="/">Home</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="loginPage centered">
      <p>We are sorry to hear that you do not wish to hear from us again. We do not use mass email marketing and never will.</p>
      <p>By pressing the button below you acknowledge that you never want to hear from us again{email ? ` (${email})` : ""}.</p>
      <Form object={{ email }} onUpdate={() => {}}>
        <FormActions
          doneLabel="Remove me from emails"
          onSaveAsync={async () => {
            await doBlacklistAsync();
          }}
        />
      </Form>
      <hr />
      <p>
        However, we would very much like to provide our services to you. Most of our services are provided free of
        charge. You set your level of interest in getting these notifications and we strictly abide by them.
      </p>
      <p>If you would like to sign up to receive these free services, press the button below.</p>
      <Form object={{}} onUpdate={() => {}}>
        <FormActions
          doneLabel="Sign up"
          onSaveAsync={async () => {
            navigate("/register");
          }}
        />
      </Form>
    </div>
  );
}
